import type { SxProps, Theme } from '@/ui/primitives';

type ResolveServerDataTableStylesArgs = {
  containerSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
};

type ResolvedSxEntry = Exclude<SxProps<Theme>, readonly unknown[] | null | undefined>;

const isResolvedSxEntry = (value: unknown): value is ResolvedSxEntry => {
  return value !== null && value !== undefined && value !== false && !Array.isArray(value);
};

const toSxArray = (value?: SxProps<Theme>): ResolvedSxEntry[] => {
  if (value === undefined || value === null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.filter(isResolvedSxEntry);
  }

  return isResolvedSxEntry(value) ? [value] : [];
};

export const resolveServerDataTableStyles = ({
  containerSx,
  sx,
}: ResolveServerDataTableStylesArgs): {
  containerStyles: ResolvedSxEntry[];
  dataGridSx: SxProps<Theme>;
} => {
  return {
    containerStyles: toSxArray(containerSx),
    dataGridSx: [{ width: '100%', minWidth: 0 }, ...toSxArray(sx)],
  };
};
